import axios from 'axios'

export default {
  namespaced: true,

  state: {
    workClientProjectsClientReportsBill: [],
    workClientProjectsClientReportsGeneralNote: {},
  },

  getters: {
    workClientProjectsClientReportsBill: (state) => {
      return state.workClientProjectsClientReportsBill
    },
    workClientProjectsClientReportsGeneralNote: (state) => {
      return state.workClientProjectsClientReportsGeneralNote
    }
  },

  mutations: {
    setWorkClientProjectsClientReportsBill(state, payload) {
      state.workClientProjectsClientReportsBill = payload
    },
    setWorkClientProjectsClientReportsGeneralNote(state, payload) {

      let id = payload.report_id
      state.workClientProjectsClientReportsGeneralNote[id] = payload
    }
  },

  actions: {
    onWorkClientProjectsClientReportsBillGrid({commit, rootState}, {report}) {
      return new Promise((resolve, reject) => {
        let url = rootState.apiDomain + '/api/admin/work/client/project/client-bill/grid?limit=0' +
          String(report ? '&filter[]=period_report_id:' + report : '')
        axios({
          url: url,
          method: 'GET',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectsClientReportsBillCreate({commit, rootState}, {data}) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/client-bill',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectsClientReportsBillUpdate({commit, rootState}, {id, data}) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/client-bill/' + id + '/reports',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectsClientReportsBillSend({commit, rootState}, {id, data}) {
      commit('setLoadingAnimationFullPage', true, { root: true })
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/client-bill/send/' + id,
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
            commit('setLoadingAnimationFullPage', false, { root: true })
          })
          .catch((err) => {
            reject(err)
            commit('setLoadingAnimationFullPage', false, { root: true })
          })
      })
    },
    onWorkClientProjectsClientReportsBillApprove({commit, rootState}, {id}) {
      commit('setLoadingAnimationFullPage', true, { root: true })
      return new Promise((resolve, reject) => {
        let url = rootState.apiDomain + '/api/admin/work/client/project/client-bill/approve/' + id
        axios({
          url: url,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
            commit('setLoadingAnimationFullPage', false, { root: true })
          })
          .catch((err) => {
            reject(err)
            commit('setLoadingAnimationFullPage', false, { root: true })
          })
      })
    },
    onWorkClientProjectsClientReportsBillSign({commit, rootState}, {id, data, }) {
      commit('setLoadingAnimationFullPage', true, { root: true })
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/client-bill/sign/' + id,
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
            commit('setLoadingAnimationFullPage', false, { root: true })
          })
          .catch((err) => {
            reject(err)
            commit('setLoadingAnimationFullPage', false, { root: true })
          })
      })
    },
    onWorkClientProjectsClientReportsBillDelete({commit, rootState}, {id}) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/client-bill/' + id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectsClientReportsBillShow({commit, rootState}, {id}) {
      return new Promise((resolve, reject) => {
        let url = rootState.apiDomain + '/api/admin/work/client/project/client-bill/' + id
        axios({
          url: url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientProjectsClientReportsBill', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
